<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12">
        <h4 style="text-align: center">8. INGRESOS</h4>

      </b-col>
      <b-col sm="12">
        <h4 style="text-align: center">Capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda</h4>
        <br />
      </b-col>
    </b-row>
    <!--INICIAL-->
    <b-container fluid v-if="tipoDeclaracion == 'INICIAL'">
      <b-row class="my-1" >
      <b-col sm="6">
        <label style="text-align: justify">Remuneración mensual neta del declarante por su cargo público (Cantidades netas despúes de impuestos) </label>
      </b-col>
      <b-col sm="6">
       <b-form-input
            :disabled="status === 'Concluida'"
            v-model="ingresos.remuneracionMensualCargoPublico.valor"            
            @change="cambios = true"
          ></b-form-input>
      </b-col>
       <b-col sm="6">
        <label style="text-align: justify">Ingreso mensual neto de la pareja y(o dependientes ecónomicos (Despúes de impuestos)</label>
      </b-col>
      <b-col sm="6">
       <b-form-input
          :disabled="status === 'Concluida'"
          v-model="ingresos.ingresoMensualNetoParejaDependiente.valor"
          
          @change="cambios = true"
          ></b-form-input>
      </b-col>
    </b-row>  
    </b-container>
    <!--MODIFICACION-->
     <b-container fluid v-if="tipoDeclaracion == 'MODIFICACION'">
      <b-row class="my-1" >
      <b-col sm="6">
        <label style="text-align: justify">Remuneración anual (Cantidades netas despúes de impuestos) </label>
      </b-col>
      <b-col sm="6">
       <b-form-input
            :disabled="status === 'Concluida'"
            v-model="ingresos.remuneracionAnualCargoPublico.valor"
            
            @change="cambios = true"
          ></b-form-input>
      </b-col>
       <b-col sm="6">
        <label style="text-align: justify">Ingreso anual de la pareja y/o dependiente económicos (Despúes de impuestos)</label>
      </b-col>
      <b-col sm="6">
       <b-form-input
          :disabled="status === 'Concluida'"
          v-model="ingresos.ingresoAnualNetoParejaDependiente.valor"
          
          @change="cambios = true"
          ></b-form-input>
      </b-col>
    </b-row>  
    </b-container>
    <!--CONCLUSION-->
    <b-container fluid v-if="tipoDeclaracion == 'CONCLUSION'">
      <b-row class="my-1" >
      <b-col sm="6">
        <label style="text-align: justify">Remuneración neta del año en curso a la fecha de conclusión por su cargo público (Cantidades netas despúes de impuestos) </label>
      </b-col>
      <b-col sm="6">
       <b-form-input
            :disabled="status === 'Concluida'"
            v-model="ingresos.remuneracionConclusionCargoPublico.valor"
            
            @change="cambios = true"
          ></b-form-input>
      </b-col>
       <b-col sm="6">
        <label style="text-align: justify">Ingreso del año en curso a la fecha de conclusión de la pareja y/o dependiente económicos (Despúes de impuestos)</label>
      </b-col>
      <b-col sm="6">
       <b-form-input
          :disabled="status === 'Concluida'"
          v-model="ingresos.ingresoConclusionNetoParejaDependiente.valor"
          
          @change="cambios = true"
          ></b-form-input>
      </b-col>
    </b-row>  
    </b-container>
    
    <b-container fluid>
    <b-card>
      <b-row>
      <b-col md="10">
        <h5>ACTIVIDAD INDUSTRIAL, COMERCIAL Y/O EMPRESARIAL</h5>
      </b-col>
      <b-col md="2">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="industrial=true" >
          AGREGAR</b-button>        
      </b-col>
      </b-row>
      
      <v-client-table    
        v-if="actividadesIndustriales.length>0"
        :columns="tablaIndustrial.columns" 
        :data="actividadesIndustriales" 
        :options="tablaIndustrial.options">
        <div style="min-width:fit-content; " slot="options" slot-scope="props" >
          <b-dropdown id="ddown1" size="sm" variant="outline-primary" text="Opciones">
            <b-dropdown-item @click="editarIndustrial(props.row._id)">Editar</b-dropdown-item>
            <b-dropdown-item @click="eliminarIndustrial(props.row._id)">Eliminar</b-dropdown-item>
          </b-dropdown>
        </div>
      </v-client-table>
    </b-card>
    
    <b-card>
      <b-row>
      <b-col md="10">
        <h5>ACTIVIDAD FINANCIERA</h5>
      </b-col>
      <b-col md="2">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="financiera=true" >
          AGREGAR</b-button>        
      </b-col>
      </b-row>
      <v-client-table    
        v-if="actividadesFinancieras.length>0"
        :columns="tablaFinanciera.columns" 
        :data="actividadesFinancieras" 
        :options="tablaFinanciera.options">
        <div style="min-width:fit-content; " slot="options" slot-scope="props" >
          <b-dropdown id="ddown1" size="sm" variant="outline-primary" text="Opciones">
            <b-dropdown-item @click="editarFinanciera(props.row._id)">Editar</b-dropdown-item>
            <b-dropdown-item @click="eliminarFinanciera(props.row._id)">Eliminar</b-dropdown-item>
          </b-dropdown>
        </div>
      </v-client-table>
    </b-card>

     <b-card>
      <b-row>
      <b-col md="10">
        <h5>SERVICIOS PROFESIONALES</h5>
      </b-col>
      <b-col md="2">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="servicio=true" >
          AGREGAR</b-button>        
      </b-col>
      </b-row>
      <v-client-table    
        v-if="serviciosProfesionales.length>0"
        :columns="tablaServicios.columns" 
        :data="serviciosProfesionales" 
        :options="tablaServicios.options">
        <div style="min-width:fit-content; " slot="options" slot-scope="props" >
          <b-dropdown id="ddown1" size="sm" variant="outline-primary" text="Opciones">
            <b-dropdown-item @click="editarServicio(props.row._id)">Editar</b-dropdown-item>
            <b-dropdown-item @click="eliminarServicio(props.row._id)">Eliminar</b-dropdown-item>
          </b-dropdown>
        </div>
      </v-client-table>
    </b-card>

 

     <b-card v-if="tipoDeclaracion !== 'INICIAL'">
      <b-row>
      <b-col md="10">
        <h5>ENAJENACIÓN DE BIENES</h5>
      </b-col>
      <b-col md="2">
        <b-button :disabled="status === 'Concluida'" variant="primary" size="sm" @click="bienes=true" >
          AGREGAR</b-button>        
      </b-col>
      </b-row>
      <v-client-table    
        v-if="enajenaciones.length>0"
        :columns="tablaBienes.columns" 
        :data="enajenaciones" 
        :options="tablaBienes.options">
        <div style="min-width:fit-content; " slot="options" slot-scope="props" >
          <b-dropdown id="ddown1" size="sm" variant="outline-primary" text="Opciones">
            <b-dropdown-item :disabled="status === 'Concluida'" @click="editarEnajenacion(props.row._id)">Editar</b-dropdown-item>
            <b-dropdown-item :disabled="status === 'Concluida'" @click="eliminarEnajenacion(props.row._id)">Eliminar</b-dropdown-item>
          </b-dropdown>
        </div>
      </v-client-table>
    </b-card>

     <b-card>
      <b-row>
      <b-col md="10">
        <h5>OTROS INGRESOS</h5>
      </b-col>
      <b-col md="2">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="otros=true" >
          AGREGAR</b-button>        
      </b-col>
      </b-row>
      <v-client-table    
        v-if="otrosIngresos.length>0"
        :columns="tablaOtros.columns" 
        :data="otrosIngresos" 
        :options="tablaOtros.options">
        <div style="min-width:fit-content; " slot="options" slot-scope="props" >
          <b-dropdown id="ddown1" size="sm" variant="outline-primary" text="Opciones">
            <b-dropdown-item @click="editarOtro(props.row._id)">Editar</b-dropdown-item>
            <b-dropdown-item @click="eliminarOtro(props.row._id)">Eliminar</b-dropdown-item>
          </b-dropdown>
        </div>
      </v-client-table>
    </b-card>

    </b-container>

    <b-container fluid>

    
      <b-col md="12">
        <h5 style="text-align: center" v-if="tipoDeclaracion === 'INICIAL'">Totales Mensuales Netos en Moneda Mexicana</h5>
        <h5 style="text-align: center" v-if="tipoDeclaracion === 'MODIFICACION'">Totales Anuales Netos en Moneda Mexicana</h5>
        <h5 style="text-align: center" v-if="tipoDeclaracion === 'CONCLUSION'">Totales Conclusión Netos en Moneda Mexicana</h5>
      </b-col>
      
  
      
      <b-row style="text-align:right ">
  
      <b-col md="2">
        <h6 >Otros ingresos: </h6>
      </b-col>
      <b-col md="2">
       <b-form-input disabled v-model="totalOtros"></b-form-input>
      </b-col>
       <b-col md="2">
        <h6>Ingreso del declarante: </h6>
      </b-col>
      <b-col md="2">
       <b-form-input disabled v-model="totalDeclarante"></b-form-input>
      </b-col>
       <b-col md="2">
        <h6 >Ingresos: </h6>
      </b-col>
      <b-col md="2">
       <b-form-input disabled v-model="totalIngreso"></b-form-input>
      </b-col>



     

      </b-row>
   </b-container>
   <br />
   <b-container fluid >
      <b-col md="12">
        <b-form-group>
          <label >ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="ingresos.aclaracionesObservaciones"
            type="text"
            placeholder="ACLARACIONES / OBSERVACIONES"
          ></b-form-input>
        </b-form-group>
      </b-col>
   </b-container>

    <br />
 
    <b-row>
      <b-col >
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando">Regresar al índice</b-button>
      </b-col>

      <b-col>
        <p v-if="cambios" class="error-text"><i>No se han guardado los cambios</i> </p>
      </b-col> 
      <b-col >
        <b-button variant="secondary" @click="verSeccion(7)" :disabled="enviando">Anterior</b-button>
        
        <b-button
          v-if="tipoDeclaracion == 'INICIAL' || tipoDeclaracion == 'CONCLUSION' && !declaracionCorta"
          class="pull-right"
          variant="primary"
          @click="guardarForm()"
          :disabled="enviando"
        >Siguiente</b-button>
        <b-button
          v-else-if="(tipoDeclaracion == 'INICIAL' || tipoDeclaracion == 'CONCLUSION') && declaracionCorta"
          class="pull-right"
          variant="primary"
          @click="guardarCorta()"
          :disabled="enviando"
        >Guardar</b-button>
       <b-button
          v-else-if="tipoDeclaracion == 'MODIFICACION' && declaracionCorta"
          class="pull-right"
          variant="primary"
          @click="guardarCorta()"
          :disabled="enviando"
          >Guardar</b-button>
          <b-button
          v-else-if="tipoDeclaracion == 'MODIFICACION' && !declaracionCorta"
          class="pull-right"
          variant="primary"
          @click="guardarForm()"
          :disabled="enviando"
          >Siguiente</b-button>
        
      </b-col>

    </b-row>

    <formIndustrial
      v-if="industrial"
      :mostrar="industrial"
      :actividadIndustial="editarActividadIndustial"
      :form8="true"
      @cancelar="industrial=false, editarActividadIndustial=null"
      @industrialAgregado="industrialAgregado"
      @industrialModificado="industrialModificado"
    />
    <formFinanciera
      v-if="financiera"
      :mostrar="financiera"
      :form8="true"
      :actividadFinanciera="editarActividadFinanciera"
      @cancelar="financiera=false, editarActividadFinanciera=null"
      @financieraAgregado="financieraAgregado"
      @financieraModificado="financieraModificado"
    />
    <formServicio
      v-if="servicio"
      :mostrar="servicio"
      :form8="true"
      :servicioProfesional="editarServicioProfesional"
      @cancelar="servicio=false, editarServicioProfesional=null"
      @servicioAgregado="servicioAgregado"
      @servicioModificado="servicioModificado"
    />
    <formOtro
      v-if="otros"
      :mostrar="otros"
      :form8="true"
      :editarIngreso="editarOtroIngreso"
      @cancelar="otros=false, editarOtroIngreso=null"
      @otroAgregado="otroAgregado"
      @otroModificado="otroModificado"
    />
     <formBienes
      v-if="bienes"
      :mostrar="bienes"
      :bienEnajenado="editarBien"
      :form8="true"
      @cancelar="bienes=false, editarBien=null"
      @bienAgregado="bienAgregado"
      @bienModificado="bienModificado"
    />
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import formIndustrial from "./formActividadIndustrial.vue"
import formFinanciera from "./formActividadFinanciera.vue"
import formServicio from "./formServicioProfesional.vue"
import formOtro from "./formOtroIngreso.vue"
import formBienes from "./formBienes.vue"
const _ = require('underscore');
export default {
  name:"ingresos",
  props: ["ingresos", "tipoDeclaracion", "status", "puesto"],
  components: { Datetime, Loader, formIndustrial, formFinanciera, formServicio, formOtro, formBienes},
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),
    actividadesIndustriales(){
      let lista = [];
      if(this.ingresos.actividadIndustialComercialEmpresarial.actividades.length>0){
        this.ingresos.actividadIndustialComercialEmpresarial.actividades.forEach(act=>{
          let item = { 
            _id:act._id,
            razonSocial: act.nombreRazonSocial,
            tipoNegocio: act.tipoNegocio,
            remuneracion: act.remuneracion.valor +' '+ act.remuneracion.moneda  
          }
          lista.push(item)
        })
      }
      return lista;
    },
    actividadesFinancieras(){
      let lista = [];
      if(this.ingresos.actividadFinanciera.actividades.length>0){
        this.ingresos.actividadFinanciera.actividades.forEach(act=>{
          let item = { 
            _id:act._id,
            tipoInstrumento: act.tipoInstrumento.valor,
            remuneracion: act.remuneracion.valor +' '+ act.remuneracion.moneda  
          }
          lista.push(item)
        })
      }
      return lista;
    },
    serviciosProfesionales(){
      let lista = [];
      if(this.ingresos.serviciosProfesionales.servicios.length>0){
        this.ingresos.serviciosProfesionales.servicios.forEach(serv=>{
          let item = { 
            _id:serv._id,
            tipoServicio:serv.tipoServicio,
            remuneracion: serv.remuneracion.valor +' '+ serv.remuneracion.moneda  
          }
          lista.push(item)
        })
      }
      return lista;
    },
    otrosIngresos(){
      let lista = [];
      if(this.ingresos.otrosIngresos.ingresos.length>0){
        this.ingresos.otrosIngresos.ingresos.forEach(ing=>{
          let item = { 
            _id:ing._id,
            tipoIngreso: ing.tipoIngreso,
            remuneracion: ing.remuneracion.valor +' '+ ing.remuneracion.moneda  
          }
          lista.push(item)
        })
      }
      return lista;
    },
    enajenaciones(){
      let lista = [];
      if(this.ingresos.enajenacionBienes.bienes.length>0){
        this.ingresos.enajenacionBienes.bienes.forEach(bien=>{
          let item = { 
            _id:bien._id,
            tipoBienEnajenado: bien.tipoBienEnajenado,
            remuneracion: bien.remuneracion.valor +' '+ bien.remuneracion.moneda  
          }
          lista.push(item)
        })
      }
      return lista;
    },
    declaracionCorta(){
      if( this.puestos.findIndex(x => x == this.puesto) == -1) {
        if(this.puesto == 'admin') return false;
        else return true;
      }
      else return false;
    }
  },
  data: function() {
    return {
        puestos: [  'AUDITOR', 
                  'AUTORIDAD PATRIMONIAL',
                  'COORDINADOR',
                  'DELEGADO',
                  'DIRECTOR',
                  'JEFATURA',
                  'JEFATURA A',
                  'JEFE DE GABINETE',
                  'JUEZ CALIFICADOR',
                  'JUEZ MUNICIPAL',
                  'REGIDOR',
                  'SECRETARIO',
                  'SECRETARIO PARTICULAR',
                  'SINDICO',
                  'SUB DIRECTOR',
                  'TESORERO',
                  'POLICIA',
                  'POLICIA DE LINEA',
                  'POLICIA PRIMERO',
                  'POLICIA SEGUNDO',
                  'POLICIA TERCERO'
                ],
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      totalOtros: 0,
      totalDeclarante: 0,
      totalIngreso: 0,
      intrumento: [
        { clave: "CAP", valor: "CAPITAL" },
        { clave: "FIN", valor: "FONDOS DE INVERSIÓN" },
        { clave: "OPR", valor: "ORGANIZACIONES PRIVADA" },
        { clave: "SSI", valor: "SEGURO DE SEPARACIÓN INDIVIDUALIZADO" },
        { clave: "VBU", valor: "VALORES BUSÁTILES" },
        { clave: "BON", valor: "BONOS" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      tipoBien: ["MUEBLE", "INMUEBLE", "VEHICULO"],
      
      industrial:false,
      editarActividadIndustial:null,
      financiera:false,
      editarActividadFinanciera:null,
      servicio:false,
      editarServicioProfesional:null,
      otros:false,
      editarOtroIngreso:null,
      bienes:false,
      editarBien:null,
      tablaIndustrial: {
          columns: ['options', 'razonSocial', 'tipoNegocio', 'remuneracion'],
          options: {
            headings: {
              options: '',
              razonSocial: 'Razón Social',
              tipoNegocio: 'Tipo de negocio',
              remuneracion: 'Remuneración'
            }, 
            perPage: 20,
            resizableColumns:false,
            texts: {
                  count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
                  first: 'Primero',
                  last: 'Último',
                  filter: "Buscar",
                  filterPlaceholder: "Ingrese...",
                  limit: "Registros:",
                  page: "Página:",
                  noResults: "No hay registros.",
                  filterBy: "Filtrando por {column}",
                  loading: 'Cargando...',
                  defaultOption: 'Select {column}',
                  columns: 'Columns'
              }
          }
      },
      tablaFinanciera: {
          columns: ['options', 'tipoInstrumento', 'remuneracion'],
          options: {
            headings: {
              options: '',
              tipoInstrumento: 'Tipo de instrumento',
              remuneracion: 'Remuneración'
            }, 
            perPage: 20,
            resizableColumns:false,
            texts: {
                  count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
                  first: 'Primero',
                  last: 'Último',
                  filter: "Buscar",
                  filterPlaceholder: "Ingrese...",
                  limit: "Registros:",
                  page: "Página:",
                  noResults: "No hay registros.",
                  filterBy: "Filtrando por {column}",
                  loading: 'Cargando...',
                  defaultOption: 'Select {column}',
                  columns: 'Columns'
              }
          }
      },
      tablaServicios: {
          columns: ['options', 'tipoServicio', 'remuneracion'],
          options: {
            headings: {
              options: '',
              tipoServicio: 'Tipo de servicio',
              remuneracion: 'Remuneración'
            }, 
            perPage: 20,
            resizableColumns:false,
            texts: {
                  count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
                  first: 'Primero',
                  last: 'Último',
                  filter: "Buscar",
                  filterPlaceholder: "Ingrese...",
                  limit: "Registros:",
                  page: "Página:",
                  noResults: "No hay registros.",
                  filterBy: "Filtrando por {column}",
                  loading: 'Cargando...',
                  defaultOption: 'Select {column}',
                  columns: 'Columns'
              }
          }
      },
      tablaOtros: {
          columns: ['options', 'tipoIngreso', 'remuneracion'],
          options: {
            headings: {
              options: '',
              tipoIngreso: 'Tipo de ingreso',
              remuneracion: 'Remuneración'
            }, 
            perPage: 20,
            resizableColumns:false,
            texts: {
                  count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
                  first: 'Primero',
                  last: 'Último',
                  filter: "Buscar",
                  filterPlaceholder: "Ingrese...",
                  limit: "Registros:",
                  page: "Página:",
                  noResults: "No hay registros.",
                  filterBy: "Filtrando por {column}",
                  loading: 'Cargando...',
                  defaultOption: 'Select {column}',
                  columns: 'Columns'
              }
          }
      },
      tablaBienes: {
          columns: ['options', 'tipoBienEnajenado', 'remuneracion'],
          options: {
            headings: {
              options: '',
              tipoBienEnajenado: 'Tipo de Bien',
              remuneracion: 'Remuneración'
            }, 
            perPage: 20,
            resizableColumns:false,
            texts: {
                  count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
                  first: 'Primero',
                  last: 'Último',
                  filter: "Buscar",
                  filterPlaceholder: "Ingrese...",
                  limit: "Registros:",
                  page: "Página:",
                  noResults: "No hay registros.",
                  filterBy: "Filtrando por {column}",
                  loading: 'Cargando...',
                  defaultOption: 'Select {column}',
                  columns: 'Columns'
              }
          }
      },
    }
  },
  methods: {
      guardarCorta(){
      let t = this.tipoDeclaracion
      this.enviando = true;

     
        axios.put(this.httpURL + "/declaraciones/V2/ingresos/" + this.$route.params.id,
            {
              ingresoValorDeclarante: t === 'INICIAL' ? this.ingresos.remuneracionMensualCargoPublico.valor : t === 'MODIFICACION' ? this.ingresos.remuneracionAnualCargoPublico.valor : this.ingresos.remuneracionConclusionCargoPublico.valor,
              ingresoMonedaDeclarante: "MXN",
              ingresoValorPareja: t === 'INICIAL' ? this.ingresos.ingresoMensualNetoParejaDependiente.valor : t === 'MODIFICACION' ? this.ingresos.ingresoAnualNetoParejaDependiente.valor : this.ingresos.ingresoConclusionNetoParejaDependiente.valor,
              ingresoMonedaPareja: "MXN",
              aclaracionesObservaciones:this.ingresos.aclaracionesObservaciones
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
            //console.log(res);
            this.$notify({ group: "foo",type: "success", duration: 2500, speed: 1000, text: res.data.mensaje });
            this.enviando = false;
            this.cambios=false;
            if (this.tipoDeclaracion === "INICIAL") {
              this.totalOtros = res.data.totales.otrosIngresosMensualesTotal.valor;
              this.totalDeclarante = res.data.totales.ingresoMensualNetoDeclarante.valor;
              this.totalIngreso = res.data.totales.totalIngresosMensualesNetos.valor;
            } else if (this.tipoDeclaracion === "MODIFICACION") {
              this.totalOtros = res.data.totales.otrosIngresosAnualesTotal.valor;
              this.totalDeclarante = res.data.totales.ingresoAnualNetoDeclarante.valor;
              this.totalIngreso = res.data.totales.totalIngresosAnualesNetos.valor;
            } else if (this.tipoDeclaracion === "CONCLUSION") {
              this.totalOtros = res.data.totales.otrosIngresosConclusionTotal.valor;
              this.totalDeclarante = res.data.totales.ingresoConclusionNetoDeclarante.valor;
              this.totalIngreso = res.data.totales.totalIngresosConclusionNetos.valor;
            }
          })
          .catch(error => {
            this.$notify({ group: "foo", type: "error", duration: 2500,speed: 1000,text: "No se pudo guardar la sección." });
            this.enviando = false;
          });


    },
    guardarForm(){
      let t = this.tipoDeclaracion
      this.enviando = true;

     
        axios.put(this.httpURL + "/declaraciones/V2/ingresos/" + this.$route.params.id,
            {
              ingresoValorDeclarante: t === 'INICIAL' ? this.ingresos.remuneracionMensualCargoPublico.valor : t === 'MODIFICACION' ? this.ingresos.remuneracionAnualCargoPublico.valor : this.ingresos.remuneracionConclusionCargoPublico.valor,
              ingresoMonedaDeclarante: "MXN",
              ingresoValorPareja: t === 'INICIAL' ? this.ingresos.ingresoMensualNetoParejaDependiente.valor : t === 'MODIFICACION' ? this.ingresos.ingresoAnualNetoParejaDependiente.valor : this.ingresos.ingresoConclusionNetoParejaDependiente.valor,
              ingresoMonedaPareja: "MXN",
              aclaracionesObservaciones:this.ingresos.aclaracionesObservaciones
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
            //console.log(res);
            this.$notify({ group: "foo",type: "success", duration: 2500, speed: 1000, text: res.data.mensaje });
            this.enviando = false;
            this.cambios=false;

            if(this.tipoDeclaracion === 'INICIAL' || this.tipoDeclaracion === 'CONCLUSION')
              this.verSeccion(8.5)
            
            else this.verSeccion(9)
            if (this.tipoDeclaracion === "INICIAL") {
              this.totalOtros = res.data.totales.otrosIngresosMensualesTotal.valor;
              this.totalDeclarante = res.data.totales.ingresoMensualNetoDeclarante.valor;
              this.totalIngreso = res.data.totales.totalIngresosMensualesNetos.valor;
            } else if (this.tipoDeclaracion === "MODIFICACION") {
              this.totalOtros = res.data.totales.otrosIngresosAnualesTotal.valor;
              this.totalDeclarante = res.data.totales.ingresoAnualNetoDeclarante.valor;
              this.totalIngreso = res.data.totales.totalIngresosAnualesNetos.valor;
            } else if (this.tipoDeclaracion === "CONCLUSION") {
              this.totalOtros = res.data.totales.otrosIngresosConclusionTotal.valor;
              this.totalDeclarante = res.data.totales.ingresoConclusionNetoDeclarante.valor;
              this.totalIngreso = res.data.totales.totalIngresosConclusionNetos.valor;
            }
          })
          .catch(error => {
            this.$notify({ group: "foo", type: "error", duration: 2500,speed: 1000,text: "No se pudo guardar la sección." });
            this.enviando = false;
          });


    },
    //INDUSTRIAL
    industrialAgregado(data){
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso;
      this.ingresos.actividadIndustialComercialEmpresarial.actividades.push(data.actividad)
      
      this.industrial=false;
    },
    editarIndustrial(id){

      this.editarActividadIndustial = this.ingresos.actividadIndustialComercialEmpresarial.actividades.map((x)=>{if(x._id==id)return x})
      //this.editarActividadIndustial = this.ingresos.actividadIndustialComercialEmpresarial.actividades[index]
      this.editarActividadIndustial = this.editarActividadIndustial[0]
     
      this.industrial=true;
    },
    industrialModificado(data){
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso;
      let index = this.ingresos.actividadIndustialComercialEmpresarial.actividades.findIndex(x=> x._id===data.actividad._id)
      this.ingresos.actividadIndustialComercialEmpresarial.actividades.splice(index,1,data.actividad)
      this.industrial=false;
    },
     //FINANCIERA
    financieraAgregado(data){

      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso;
      this.ingresos.actividadFinanciera.actividades.push(data.actividad)
      this.financiera=false;
    },
    editarFinanciera(id){
      this.editarActividadFinanciera = this.ingresos.actividadFinanciera.actividades.find(x=>x._id==id)
      this.financiera=true;

    },
    financieraModificado(data){
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso;
      let index =  this.ingresos.actividadFinanciera.actividades.findIndex(x=> x._id===data.actividad._id)
      this.ingresos.actividadFinanciera.actividades.splice(index,1,data.actividad)
      this.financiera=false;
    },
    //SERVICIOS PROFESIONALES
    servicioAgregado(data){
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso;
      this.ingresos.serviciosProfesionales.servicios.push(data.servicio)
      this.servicio=false;
    },
    editarServicio(id){
      this.editarServicioProfesional = this.ingresos.serviciosProfesionales.servicios.find(x=>x._id==id)
      this.servicio=true;
    },
    servicioModificado(data){
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso;
      let index =  this.ingresos.serviciosProfesionales.servicios.findIndex(x=> x._id===data.servicio._id)
      this.ingresos.serviciosProfesionales.servicios.splice(index,1,data.servicio)
      this.servicio=false;
    },
    //OTROS
    otroAgregado(data){
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso;

      this.ingresos.otrosIngresos.ingresos.push(data.otroIngreso)
      this.otros=false;
    },
    editarOtro(id){
      this.editarOtroIngreso = this.ingresos.otrosIngresos.ingresos.find(x=>x._id==id)
      this.otros=true;

    },
    otroModificado(data){
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso; 
      let index =  this.ingresos.otrosIngresos.ingresos.findIndex(x=> x._id===data.actividad._id)
      this.ingresos.otrosIngresos.ingresos.splice(index,1,data.actividad)
      this.otros=false;
      this.editarOtroIngreso=null;
    },
      //BIENES
    bienAgregado(data){
    
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso; 
      this.ingresos.enajenacionBienes.bienes.push(data.bien)
      this.bien=false;
    },
    editarEnajenacion(id){
      this.editarBien = this.ingresos.enajenacionBienes.bienes.find(x=>x._id==id)
      this.bienes=true;

    },
    bienModificado(data){
      this.totalesOtros = data.totales.totalOtros;
      this.totalDeclarante = data.totales.totalDeclarante;
      this.totalIngreso = data.totales.totalIngreso; 
      let index =  this.ingresos.enajenacionBienes.bienes.findIndex(x=> x._id===data.bien._id)
      this.ingresos.enajenacionBienes.bienes.splice(index,1,data.bien)
      this.bienes=false
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
   
    ///////////////////ELIMINACION
    eliminarIndustrial(id) {
      swal({
          text: "¿Está seguro en eliminar la actividad?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            axios.delete(this.httpURL + "/declaraciones/V2/ingresos/" +  this.$route.params.id +"/actividadIndustial/" +id,
              { headers: { token: this.sessionToken } })
              .then(res => {
                if (res.data.ok) {
                  this.enviando = false;
                  let index = this.ingresos.actividadIndustialComercialEmpresarial.actividades.findIndex(x=>x._id==id)
                  this.ingresos.actividadIndustialComercialEmpresarial.actividades.splice(index,1)
                  
                  if (this.tipoDeclaracion === "INICIAL") {
                    this.totalOtros = res.data.totales.otrosIngresosMensualesTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoMensualNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosMensualesNetos.valor;
                  } else if (this.tipoDeclaracion === "MODIFICACION") {
                    this.totalOtros = res.data.totales.otrosIngresosAnualesTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoAnualNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosAnualesNetos.valor;
                  } else if (this.tipoDeclaracion === "CONCLUSION") {
                    this.totalOtros = res.data.totales.otrosIngresosConclusionTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoConclusionNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosConclusionNetos.valor;
                  }
                }
                this.$notify({group: "foo", type: "success", duration: 2500, speed: 1000, text: res.data.mensaje});
              })
              .catch(error => {
                this.$notify({group: "foo", type: "error", duration: 2500, speed: 1000,  text: "No se pudo guardar la sección." });
                this.enviando = false;
           
              });
          }
        });
    },
    eliminarFinanciera(id) {
      swal({
          text: "¿Está seguro en eliminar la actividad?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            axios.delete(this.httpURL + "/declaraciones/V2/ingresos/" +  this.$route.params.id +"/actividadFinanciera/" +id,
              { headers: { token: this.sessionToken } })
              .then(res => {
                if (res.data.ok) {
                  this.enviando = false;
                  let index = this.ingresos.actividadFinanciera.actividades.findIndex(x=>x._id==id)
                  this.ingresos.actividadFinanciera.actividades.splice(index,1)
                  
                  if (this.tipoDeclaracion === "INICIAL") {
                    this.totalOtros = res.data.totales.otrosIngresosMensualesTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoMensualNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosMensualesNetos.valor;
                  } else if (this.tipoDeclaracion === "MODIFICACION") {
                    this.totalOtros = res.data.totales.otrosIngresosAnualesTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoAnualNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosAnualesNetos.valor;
                  } else if (this.tipoDeclaracion === "CONCLUSION") {
                    this.totalOtros = res.data.totales.otrosIngresosConclusionTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoConclusionNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosConclusionNetos.valor;
                  }
                }
                this.$notify({group: "foo", type: "success", duration: 2500, speed: 1000, text: res.data.mensaje});
              })
              .catch(error => {
                this.$notify({group: "foo", type: "error", duration: 2500, speed: 1000,  text: "No se pudo guardar la sección." });
                this.enviando = false;
           
              });
          }
        });
    },
    eliminarServicio(id) {
      swal({
          text: "¿Está seguro en eliminar el servicio?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            axios.delete(this.httpURL + "/declaraciones/V2/ingresos/" +  this.$route.params.id +"/serviciosProfesionales/" +id,
              { headers: { token: this.sessionToken } })
              .then(res => {
                if (res.data.ok) {
                  this.enviando = false;
                  let index = this.ingresos.serviciosProfesionales.servicios.findIndex(x=>x._id==id)
                  this.ingresos.serviciosProfesionales.servicios.splice(index,1)
                  
                  if (this.tipoDeclaracion === "INICIAL") {
                    this.totalOtros = res.data.totales.otrosIngresosMensualesTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoMensualNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosMensualesNetos.valor;
                  } else if (this.tipoDeclaracion === "MODIFICACION") {
                    this.totalOtros = res.data.totales.otrosIngresosAnualesTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoAnualNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosAnualesNetos.valor;
                  } else if (this.tipoDeclaracion === "CONCLUSION") {
                    this.totalOtros = res.data.totales.otrosIngresosConclusionTotal.valor;
                    this.totalDeclarante = res.data.totales.ingresoConclusionNetoDeclarante.valor;
                    this.totalIngreso = res.data.totales.totalIngresosConclusionNetos.valor;
                  }
                }
                this.$notify({group: "foo", type: "success", duration: 2500, speed: 1000, text: res.data.mensaje});
              })
              .catch(error => {
                this.$notify({group: "foo", type: "error", duration: 2500, speed: 1000,  text: "No se pudo guardar la sección." });
                this.enviando = false;
           
              });
          }
        });
    },
   
    ////////////////////////////////////////////////////////financiera///////////////////////////////////////////////////////////

    encuentraInstrumento(index) {
      let indice;
      indice = this.intrumento.findIndex(
        x =>
          x.clave ===
          this.ingresos.actividadFinanciera.actividades[index].tipoInstrumento
            .clave
      );
      this.ingresos.actividadFinanciera.actividades[
        index
      ].tipoInstrumento.valor = this.intrumento[indice].valor;
    },

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////////////////////////otros ingresos/////////////////////////////////////////////////////////////////////

    guardarIngreso(index) {
      if (this.ingresos.otrosIngresos.ingresos[index]._id.length > 3) {
     
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/ingresos/" +
              this.$route.params.id +
              "/otrosIngresos/" +
              this.ingresos.otrosIngresos.ingresos[index]._id,
            {
              remuneracionValor: this.ingresos.otrosIngresos.ingresos[index]
                .remuneracion.valor,
              remuneracionMoneda: "MXN",
              tipoIngreso: this.ingresos.otrosIngresos.ingresos[index]
                .tipoIngreso
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           
            if (res.data.ok === true) {
              this.cambiosIngresos[index] = false;
              if (this.tipoDeclaracion === "INICIAL") {
                this.totalOtros =
                  res.data.totales.otrosIngresosMensualesTotal.valor;
                this.totalDeclarante =
                  res.data.totales.ingresoMensualNetoDeclarante.valor;
                this.totalIngreso =
                  res.data.totales.totalIngresosMensualesNetos.valor;
              } else if (this.tipoDeclaracion === "MODIFICACION") {
                this.totalOtros =
                  res.data.totales.otrosIngresosAnualesTotal.valor;
                this.totalDeclarante =
                  res.data.totales.ingresoAnualNetoDeclarante.valor;
                this.totalIngreso =
                  res.data.totales.totalIngresosAnualesNetos.valor;
              } else if (this.tipoDeclaracion === "CONCLUSION") {
                this.totalOtros =
                  res.data.totales.otrosIngresosConclusionTotal.valor;
                this.totalDeclarante =
                  res.data.totales.ingresoConclusionNetoDeclarante.valor;
                this.totalIngreso =
                  res.data.totales.totalIngresosConclusionNetos.valor;
              }
            }
            if (res.data.mensaje === "Valor no válido") {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            } else {
              this.cambiosIngresos[index] = false;
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            }
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
          });
      } else {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/ingresos/" +
              this.$route.params.id +
              "/otrosIngresos",
            {
              remuneracionValor: this.ingresos.otrosIngresos.ingresos[index]
                .remuneracion.valor,
              remuneracionMoneda: "MXN",
              tipoIngreso: this.ingresos.otrosIngresos.ingresos[index]
                .tipoIngreso
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
            
            if (res.data.ok === true) {
              this.ingresos.otrosIngresos.ingresos[
                index
              ]._id = res.data.ingreso._id;
              this.cambiosIngresos[index] = false;
              if (this.tipoDeclaracion === "INICIAL") {
                this.totalOtros =
                  res.data.totales.otrosIngresosMensualesTotal.valor;
                this.totalDeclarante =
                  res.data.totales.ingresoMensualNetoDeclarante.valor;
                this.totalIngreso =
                  res.data.totales.totalIngresosMensualesNetos.valor;
              } else if (this.tipoDeclaracion === "MODIFICACION") {
                this.totalOtros =
                  res.data.totales.otrosIngresosAnualesTotal.valor;
                this.totalDeclarante =
                  res.data.totales.ingresoAnualNetoDeclarante.valor;
                this.totalIngreso =
                  res.data.totales.totalIngresosAnualesNetos.valor;
              } else if (this.tipoDeclaracion === "CONCLUSION") {
                this.totalOtros =
                  res.data.totales.otrosIngresosConclusionTotal.valor;
                this.totalDeclarante =
                  res.data.totales.ingresoConclusionNetoDeclarante.valor;
                this.totalIngreso =
                  res.data.totales.totalIngresosConclusionNetos.valor;
              }
            }
            if (res.data.mensaje === "Valor no válido") {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            } else if (
              res.data.mensaje === "Actividad agregada correctamente"
            ) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            }

            this.enviando = false;
            this.cambiosIngresos[index] = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
          });
      }
    },

    nuevoIngreso() {
  
    },

    eliminarOtro(id) {
     swal({
          text: "¿Está seguro en eliminar el ingreso?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            axios
              .delete(
                this.httpURL +
                  "/declaraciones/V2/ingresos/" +
                  this.$route.params.id +
                  "/otrosIngresos/" +id,

                { headers: { token: this.sessionToken } }
              )
              .then(res => {
            
                if (res.data.ok == true) {
                  this.$notify({
                    group: "foo",
                    type: "success",
                    duration: 2500,
                    speed: 1000,
                    text: res.data.mensaje
                  });
                  let index =  this.ingresos.otrosIngresos.ingresos.findIndex(x=> x._id==id)
                  this.ingresos.otrosIngresos.ingresos.splice(index, 1);
                  

                  if (this.tipoDeclaracion === "INICIAL") {
                    this.totalOtros =
                      res.data.totales.otrosIngresosMensualesTotal.valor;
                    this.totalDeclarante =
                      res.data.totales.ingresoMensualNetoDeclarante.valor;
                    this.totalIngreso =
                      res.data.totales.totalIngresosMensualesNetos.valor;
                  } else if (this.tipoDeclaracion === "MODIFICACION") {
                    this.totalOtros =
                      res.data.totales.otrosIngresosAnualesTotal.valor;
                    this.totalDeclarante =
                      res.data.totales.ingresoAnualNetoDeclarante.valor;
                    this.totalIngreso =
                      res.data.totales.totalIngresosAnualesNetos.valor;
                  } else if (this.tipoDeclaracion === "CONCLUSION") {
                    this.totalOtros =
                      res.data.totales.otrosIngresosConclusionTotal.valor;
                    this.totalDeclarante =
                      res.data.totales.ingresoConclusionNetoDeclarante.valor;
                    this.totalIngreso =
                      res.data.totales.totalIngresosConclusionNetos.valor;
                  }
                }

                this.enviando = false;
              })
              .catch(error => {
                this.$notify({
                  group: "foo",
                  type: "error",
                  duration: 2500,
                  speed: 1000,
                  text: "No se pudo eliminar la sección."
                });
                this.enviando = false;
               
              });
          }
        });
     
    },

    ////////////////////////////////////////////////enajenación de bienes////////////////////////////////////////////////////////

    guardarEnajenacion(index) {
      if (this.ingresos.enajenacionBienes.bienes[index]._id.length > 3) {
    
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/ingresos/" +
              this.$route.params.id +
              "/enajenacionBienes/" +
              this.ingresos.enajenacionBienes.bienes[index]._id,
            {
              remuneracionValor: this.ingresos.enajenacionBienes.bienes[index]
                .remuneracion.valor,
              remuneracionMoneda: "MXN",
              tipoBienEnajenado: this.ingresos.enajenacionBienes.bienes[index]
                .tipoBienEnajenado
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           

            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.enviando = false;
            this.cambiosBienes[index] = false;
            this.$forceUpdate();
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
          });
      } else {
      
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/ingresos/" +
              this.$route.params.id +
              "/enajenacionBienes",
            {
              remuneracionValor: this.ingresos.enajenacionBienes.bienes[index]
                .remuneracion.valor,
              remuneracionMoneda: "MXN",
              tipoBienEnajenado: this.ingresos.enajenacionBienes.bienes[index]
                .tipoBienEnajenado
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
    
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.ingresos.enajenacionBienes.bienes[index]._id =
              res.data.bien._id;
            this.enviando = false;
            this.cambiosBienes[index] = false;
            this.$forceUpdate();
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
          });
      }
    },

    nuevoBien() {
      let nuevo = {
        _id: this.contadorIngresos,
        remuneracion: { valor: 0, moneda: "MXN" },
        tipoBienEnajenado: null
      };
      this.ingresos.enajenacionBienes.bienes.push(nuevo);
      this.cambiosBienes.push(false);
      this.contadorBienes++;
    },

    eliminarEnajenacion(id) {
      this.enviando=true;
        swal({
          text: "¿Está seguro en eliminar el bien?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            axios
              .delete(
                this.httpURL +
                  "/declaraciones/V2/ingresos/" +
                  this.$route.params.id +
                  "/enajenacionBienes/" +
                  id,

                { headers: { token: this.sessionToken } }
              )
              .then(res => {
               
                if (res.data.ok == true) {
                  this.$notify({
                    group: "foo",
                    type: "success",
                    duration: 2500,
                    speed: 1000,
                    text: res.data.mensaje
                  });
                  let index =  this.ingresos.enajenacionBienes.bienes.findIndex(x=>x._id == id)
                  this.ingresos.enajenacionBienes.bienes.splice(index, 1);
                  if (this.tipoDeclaracion === "MODIFICACION") {
                    this.totalOtros =
                      res.data.totales.otrosIngresosAnualesTotal.valor;
                    this.totalDeclarante =
                      res.data.totales.ingresoAnualNetoDeclarante.valor;
                    this.totalIngreso =
                      res.data.totales.totalIngresosAnualesNetos.valor;
                  } else if (this.tipoDeclaracion === "CONCLUSION") {
                    this.totalOtros =
                      res.data.totales.otrosIngresosConclusionTotal.valor;
                    this.totalDeclarante =
                      res.data.totales.ingresoConclusionNetoDeclarante.valor;
                    this.totalIngreso =
                      res.data.totales.totalIngresosConclusionNetos.valor;
                  }
                }

                this.enviando = false;
              })
              .catch(error => {
                this.$notify({
                  group: "foo",
                  type: "error",
                  duration: 2500,
                  speed: 1000,
                  text: "No se pudo eliminar la sección."
                });
                this.enviando = false;
                
              });
          }
        });
     
    }
  },
  created() {
    

    if (this.tipoDeclaracion === "INICIAL") {
      this.totalOtros = this.ingresos.otrosIngresosMensualesTotal.valor;
      this.totalDeclarante = this.ingresos.ingresoMensualNetoDeclarante.valor;
      this.totalIngreso = this.ingresos.totalIngresosMensualesNetos.valor;
    } else if (this.tipoDeclaracion === "MODIFICACION") {
      this.totalOtros = this.ingresos.otrosIngresosMensualesTotal.valor;
      this.totalDeclarante = this.ingresos.ingresoAnualNetoDeclarante.valor;
      this.totalIngreso = this.ingresos.totalIngresosAnualesNetos.valor;
    } else if (this.tipoDeclaracion === "CONCLUSION") {
      this.totalOtros = this.ingresos.otrosIngresosConclusionTotal.valor;
      this.totalDeclarante = this.ingresos.ingresoConclusionNetoDeclarante.valor;
      this.totalIngreso = this.ingresos.totalIngresosConclusionNetos.valor;
    }

   

    
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
